import {TYPE_LOGIN_ENUM} from '@/types/enums'

export interface initialStateInterface {
  typeLogin: TYPE_LOGIN_ENUM
  account: string | null
  jwt: string
  dataMap: {x: number; y: number; zoom: number} | null
  refreshToken: string
  guestMode: boolean
  dontShowAgain: boolean
  language: string
  emailForRegistration: string | null
  isErrorModalByCatch: boolean
  modalErrorCode:
    | object
    | {code: number; message: string; description?: string}
    | null
}

export const initialState: initialStateInterface = {
  typeLogin: TYPE_LOGIN_ENUM.none,
  account: null,
  jwt: '',
  dataMap: null,
  refreshToken: '',
  guestMode: false,
  dontShowAgain: false,
  language: 'en',
  emailForRegistration: null,
  isErrorModalByCatch: false,
  modalErrorCode: {},
}
